import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("pula_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("pula_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  // Capture a campus tag from any share/QR link (?campus=) — for the Campus Launch Kit density tracking.
  useEffect(() => {
    try {
      const c = new URLSearchParams(window.location.search).get("campus");
      if (c) localStorage.setItem("pula_campus", c.slice(0, 80));
    } catch { /* ignore */ }
  }, []);

  // Once a member is signed in, record their campus once (then clear it).
  useEffect(() => {
    const c = localStorage.getItem("pula_campus");
    if (user && c) {
      api.post("/campus/join", { campus: c })
        .then(() => localStorage.removeItem("pula_campus"))
        .catch(() => {});
    }
  }, [user]);

  const setSession = (data) => {
    if (data?.token) localStorage.setItem("pula_token", data.token);
    setUser(data.user);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("pula_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, setSession, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
